import Lenis from "lenis";

let lenis = null;

export const initLenis = () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null;
  lenis = new Lenis({ duration: 1.25, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
  const raf = (time) => {
    lenis && lenis.raf(time);
    window.__lenisRaf = requestAnimationFrame(raf);
  };
  window.__lenisRaf = requestAnimationFrame(raf);
  return lenis;
};

export const destroyLenis = () => {
  cancelAnimationFrame(window.__lenisRaf);
  lenis && lenis.destroy();
  lenis = null;
};

export const scrollToTop = () => (lenis ? lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0));

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -70, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const lockScroll = (locked) => {
  if (!lenis) return;
  locked ? lenis.stop() : lenis.start();
};
